import PageHelper from '../../helpers/page-helper';
import ProductData from '../../model/product-data';

export default class AsyncQuickAdd {
  private endpoint: string;
  protected productCode: JQuery;
  protected submit: JQuery;
  protected errorContainer: JQuery;
  protected successContainer: JQuery;
  protected formSubmitted = false;

  constructor(protected form: JQuery, private callback: (product: ProductData) => void) {
    this.endpoint = this.form.data('endpoint') as string;
    this.productCode = form.find('.js-quick-add-input');
    this.submit = form.find('.js-quick-add-button');
    this.errorContainer = form.find('.js-quick-add-error-container');
    this.successContainer = form.find('.js-quick-add-success-container');
    this.bindAddProductOnSubmit();
    this.bindRemoveErrorOnInput();
  }

  isValid(): boolean {
    return this.form.parsley().isValid() && !this.form.hasClass('has-error');
  }

  private bindAddProductOnSubmit() {
    const submit = () => {
      if (this.formSubmitted) {
        return;
      }

      if (!this.productCode.val()) {
        this.productCode.addClass('parsley-error');
        return;
      }

      PageHelper.showLoadingIndicator();
      this.submit.prop('disabled', true);

      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      $.ajax({
        url: `${window.ACC.config.encodedContextPath}${this.endpoint}?code=${this.productCode.val() as string}`,
        type: 'GET',
      })
        .done((product: ProductData) => {
          this.callback(product);
          this.productCode.val('');
        })
        .fail((err) => {
          window.NotificationHelper.clearNotifications();
          window.NotificationHelper.showError(JSON.parse(err.responseText));
        })
        .always(() => {
          PageHelper.clearLoadingIndicator();
          this.submit.prop('disabled', false);
          this.formSubmitted = false;
        });
    };

    this.productCode.on('keydown', (e) => {
      if (e.key === 'Enter') {
        submit();
        e.preventDefault();
      }
    });

    this.submit.on('click', submit);
  }

  private bindRemoveErrorOnInput(): void {
    this.productCode.on('input', () => {
      this.productCode.removeClass('parsley-error');
    });
  }
}
